<template>
    <div class="acomodar">
        <Aprobacion/>

        <!-- <iframe src="http://futbollatam.com/en-vivo/espn-1/?ver"  width="100" height="200" frameborder="0"></iframe> -->
    </div>
</template>
<script>
import Aprobacion from '@/components/ModSeleccion/Puesto/Aprobacion.vue';

export default {
    name: "SolimanologPuestosAprobados",
    data() {
        return {};
    },
    mounted() {
    },
    methods: {},
    components: { Aprobacion }
};
</script>

<style  scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left:15px;
  margin-right: 15px;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  overflow-x: auto;
  overflow-y: none;
}
</style>